import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLydiaComponent } from './simple-icons-lydia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLydiaComponent ],
    exports:      [ SimpleIconsLydiaComponent ],
    bootstrap:    []
})
export class SimpleIconsLydiaModule {}
